import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from "vue-analytics"
import VueI18n from 'vue-i18n'
import VueZoomOnHover from 'vue-zoom-on-hover'

import App from '../critical_editions/App.vue'
import store from '../critical_editions/store'

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueAnalytics, {
  id: gon.trackerId || 'UA-XXX-1',
  checkDuplicatedScript: true,
  debug: {sendHitTask: gon.trackerId}
})
Vue.use(VueZoomOnHover)
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: gon.i18n.locale,
  messages: {[gon.i18n.locale]: gon.i18n.translations}
})

document.addEventListener('DOMContentLoaded', () => {
  const main = document.getElementById('main')
  const el = main.appendChild(document.createElement('div'))
  new Vue({i18n, el, store: new Vuex.Store(store), render: h => h(App)})
});